import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { webUrlLogin } from "../Utility/config";
import { useCallback } from "react";
import useRazorpay from "react-razorpay";
import configData from "../../config.json";
import "../../Pricing.css";
import InteraktScript from "../../common/InteraktScript";
import Pricingmain from "../../common/Pricing/Pricingmain";
import Pricingdetails from "../../common/Pricing/Pricingdetails";

const WEEK_PRICE_OPTIONS = [
  { week: 1, deduction: 0 },
  { week: 2, deduction: 0 },
  { week: 3, deduction: 0 },
  { week: 4, deduction: 0 },
  { week: 5, deduction: 0 },
  { week: 6, deduction: 0 },
  { week: 7, deduction: 0 },
  { week: 8, deduction: 0 },
  { week: 9, deduction: 400 },
  { week: 10, deduction: 400 },
  { week: 11, deduction: 1375 },
  { week: 12, deduction: 1825 },
  { week: 13, deduction: 3463 },
  { week: 14, deduction: 3463 },
  { week: 15, deduction: 4763 },
  { week: 16, deduction: 5213 },
  { week: 17, deduction: 5613 },
  { week: 18, deduction: 5613 },
  { week: 19, deduction: 8043 },
  { week: 20, deduction: 8043 },
  { week: 21, deduction: 8643 },
  { week: 22, deduction: 8643 },
  { week: 23, deduction: 11368 },
  { week: 24, deduction: 11368 },
  { week: 25, deduction: 13718 },
  { week: 26, deduction: 14168 },
  { week: 27, deduction: 14168 },
  { week: 28, deduction: 14168 },
];

const SONOGRAPHY_OPTIONS = [
  { id: 1, name: "Dating Ultrasound", deduction: 1080 },
  { id: 2, name: "First Routine (Growth) Sonography", deduction: 1200 },
  { id: 3, name: "NT Scan", deduction: 1200 },
  { id: 4, name: "Anomly Scan", deduction: 2100 },
  { id: 5, name: "Fetal 2D Echo-Cardiography", deduction: 1800 },
  { id: 6, name: "Fetal Well-Being", deduction: 1200 },
  { id: 7, name: "Colour Doppler + Second Growth Scan", deduction: 3300 },
  { id: 8, name: "Third Routine (Growth) Sonography", deduction: 1200 },
];

const SONOGRAPHY_RULES = {
  1: [],
  2: [],
  3: [],
  4: [],
  5: [],
  6: [],
  7: [],
  8: [],
  9: [],
  10: [],
  11: [1],
  12: [1],
  13: [1],
  14: [1],
  15: [1, 3],
  16: [1, 3],
  17: [1, 3],
  18: [1, 3],
  19: [1, 3],
  20: [1, 3],
  21: [1, 3],
  22: [1, 3],
  23: [1, 3, 4],
  24: [1, 3, 4],
  25: [1, 3, 4, 5],
  26: [1, 3, 4, 5],
  27: [1, 3, 4, 5],
  28: [1, 3, 4, 5],
};

let paymentid;
let orderid;
let razorpaysignature1;
function Pricing() {
  const pricingparacontent = {
    color: "#7A8B94",
    fontSize: "14px",
    lineHeight: "150%"
  }
  const pricecherishcare =
  {
    color: "#3C4852",
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "120%",
  }
  const imgrad = {
    borderRadius: "10px",
  }
  const headerRef = useRef(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const [areas, setAreas] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [areaData, setAreaData] = useState(false);
  const [packageDetails, setPackageDetails] = useState();
  const [nextpg, setNextpg] = useState(false);
  const [pricing, setPricing] = useState("");
  const [patientdata, setPatientdata] = useState("");
  const [paymentId, setPaymentId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [razorpaysignature, setRazorpaySignature] = useState(null);
  const [areaprice, setAreaprice] = useState(0);
  const [userid, setUserid] = useState(0);
  const [Razorpay] = useRazorpay();
  const naviagte = useNavigate();

  const [selectedWeek, setSelectedWeek] = useState("");
  const [pricselectedMonth, setpricSelectedMonth] = useState("");
  const [selectedSonography, setSelectedSonography] = useState([]);
  const handleChangeMonth = (e) => {
    const week = e.target.value;
    const selectedWeekOption = WEEK_PRICE_OPTIONS.find(
      (item) => String(item.week) === week
    );

    setSelectedWeek(week);
    setpricSelectedMonth(selectedWeekOption ? selectedWeekOption.deduction : "");
    setSelectedSonography([]);
    setCouponApplied(false);
    setCouponError(false);
    setCouponMessage("");
  };
  console.log("Selected Month Value:", pricselectedMonth);
  const discountedPrice = areaprice - (parseInt(pricselectedMonth) || 0);
  // const [couponCode, setCouponCode] = useState("");
  // const [couponApplied, setCouponApplied] = useState(false);
  // const [finalAmount, setFinalAmount] = useState(null);
  // const [couponError, setCouponError] = useState(false);

  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponError, setCouponError] = useState(false);
  const [finalAmount, setFinalAmount] = useState(null);
  const [couponMessage, setCouponMessage] = useState("");

  const availableSonographyOptions = selectedWeek
    ? SONOGRAPHY_OPTIONS.filter((item) => {
      const removedIds = SONOGRAPHY_RULES[Number(selectedWeek)] || [];
      return !removedIds.includes(item.id);
    })
    : [];

  const selectedSonographyOptions = availableSonographyOptions.filter((item) =>
    selectedSonography.includes(String(item.id))
  );
  const selectedSonographyDeduction = selectedSonographyOptions.reduce(
    (total, item) => total + item.deduction,
    0
  );

  const handleSonographyChange = (e) => {
    const { value, checked } = e.target;

    setSelectedSonography((prev) => {
      if (checked) {
        return prev.includes(value) ? prev : [...prev, value];
      }

      return prev.filter((item) => item !== value);
    });
    setCouponApplied(false);
    setCouponError(false);
    setCouponMessage("");
  };



  useEffect(() => {
    if (areaprice > 0) {
      const baseAmount =
        areaprice -
        (parseFloat(pricselectedMonth) || 0) -
        selectedSonographyDeduction;
      setFinalAmount(baseAmount);
    }
  }, [areaprice, pricselectedMonth, selectedSonographyDeduction]);


  useEffect(() => {
    window.scrollTo(0, 0);
    getAreas();
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
    getsingleuserdetail();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // Timeline
  window.addEventListener('scroll', () => {
    const timeline = document.querySelector('.timeline-line');
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollTop = window.scrollY;
    const scrollPercent = (scrollTop / docHeight) * 100;

    if (timeline) {
      timeline.style.height = `${scrollPercent}%`;
    }
  });

  //  Timeliinr
  const handleScroll = () => {
    setIsAtTop(window.scrollY === 0);
  };

  const applyCoupon = async () => {
    if (!finalAmount || finalAmount <= 0) return;

    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/coupons/validate`,
        {
          code: couponCode,
          amount: finalAmount,
        }
      );

      if (response.data.success) {
        setFinalAmount(response.data.finalAmount);
        setCouponApplied(true);
        setCouponError(false);
      } else {
        setCouponApplied(false);
        setCouponError(true);
        setCouponMessage(response.data.message || "Invalid coupon code");
      }
    } catch (error) {
      setCouponApplied(false);
      setCouponError(true);
      console.error("Coupon error:", error);
    }
  };



  const getsingleuserdetail = async () => {
    try {
      const response = await axios.post(`${configData.SERVER_API_URL}/users/get_single_user`, {
        userId: localStorage.getItem("userId"),
      });

      if (response.data.success) {
        setPatientdata(response.data.user);
      } else {
        console.error(
          "Error adding medical registration details:",
          response.data.error
        );
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  console.log("FINAL AMOUNT:", finalAmount);

  const calling = async () => {
    if (!finalAmount || finalAmount <= 0) {
      alert("Invalid payment amount");
      return null;
    }

    const pr = Math.round(finalAmount * 100);

    const response = await axios.post(
      `${configData.SERVER_API_URL}/checkout/getorderId`,
      {
        amount: pr,
        currency: "INR",
      }
    );

    return response.data;
  };


  const handlePayment = useCallback(async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      if (userId != 0) {
        const response = await axios.post(
          `${configData.SERVER_API_URL}/users/get_single_user`,
          {
            userId: userId,
          }
        );
        if (response.data.success) {
          const user = response.data.user;

          const order = await calling();
          console.log("order", order);
          const options = {
            key: "rzp_live_5FkwM0dSiSrFis",
            key_secret: "YZPhYx4f6silMc8BHobIudxD",
            // amount: areaprice * 100,
            // amount: discountedPrice * 100,
            amount: finalAmount * 100,
            currency: "INR",
            name: "Myprega",
            description: "Test Transaction",
            image: "https://myprega.com/logo.png",
            order_id: order?.order_details.id,
            handler: (res) => {
              paymentid = res.razorpay_payment_id;
              orderid = res.razorpay_order_id;
              razorpaysignature1 = res.razorpay_signature;

              setPaymentId(paymentid);
              setOrderId(orderid);
              setRazorpaySignature(razorpaysignature);

              console.log("Payment ID:", paymentid, paymentId);
              console.log("Order ID:", orderid, orderId);
              console.log(
                "Razorpay Signature:",
                razorpaysignature1,
                razorpaysignature
              );

              paymentdetail(paymentid, orderid, razorpaysignature1);
            },
            prefill: {
              name: user.fname + " " + user.lname, //user deytails
              email: user.email,
              contact: user.phone,
            },
            notes: {
              address: "Razorpay Corporate Office",
            },
            theme: {
              color: "#3399cc",
            },
          };

          const rzpay = new Razorpay(options);
          rzpay.open();
        }
      } else {
        alert("Please SignUp");
      }
    } else {
      naviagte("/patient/loginform");
    }

  }, [finalAmount, couponApplied, couponCode, Razorpay]);
  // }, [discountedPrice, Razorpay]);
  // }, [areaprice, Razorpay]);

  const options = {
    key: "rzp_test_mel87ldPGvyLYj", // Replace with your Razorpay Key ID
    amount: 100, // Amount in paise
    currency: "INR",
    name: "Acme Corp",
    description: "Test Transaction",
    image: "https://example.com/your_logo",
    order_id: "order_MyNFHL1FQ6cjgh", // Replace with your Order ID
    callback_url: "https://eneqd3r9zrjok.x.pipedream.net/",
    prefill: {
      name: "Gaurav Kumar",
      email: "gaurav.kumar@example.com",
      contact: "9000090000",
    },
    notes: {
      address: "Razorpay Corporate Office",
    },
    theme: {
      color: "#3399cc",
    },
  };
  const paymentdetail = async (paymentid, orderid, razorpaysignature1) => {
    try {
      const userId = localStorage.getItem("userId");
      // const p = areaprice;
      // const p = discountedPrice;
      const p = finalAmount;

      const response = await axios.post(
        `${configData.SERVER_API_URL}/checkout/store_payment_details`,
        {
          user_id: userId,
          razorpay_payment_id: paymentid,
          razorpay_order_id: orderid,
          payment_status: "SUCCESS",
          razorpay_signature: razorpaysignature1,
          amount: p,
        }
      );
      if (response.data.success) {
        console.log("sent detail successfully");
        getsingleuserdetail();
        if (patientdata.payment_status == true) {
          window.location.href = `${webUrlLogin}`;
        }
      }
    } catch {
      console.log("error");
    }
  };

  const getAreas = async () => {
    try {
      const response = await axios.get(
        `${configData.SERVER_API_URL}/users/get_areas_list`,
        {}
      );
      if (response.data.success) {
        setAreas(response.data?.list);
      }
    } catch (error) {
      console.error("Error get areas:", error);
    }
  };

  const handleChangeGetDetails = async (e) => {
    const areaId = e.target.value;
    let currentarea = areas.find((item) => item.id == areaId)?.pricing;
    setAreaprice(currentarea);
    setSelectedValue(areaId);
    setSelectedWeek("");
    setpricSelectedMonth("");
    setSelectedSonography([]);
    setCouponApplied(false);
    setCouponError(false);
    setCouponMessage("");

    if (areaId) {
      try {
        const response = await axios.post(
          `${configData.SERVER_API_URL}/common/getAreaDetailsById`,
          {
            area_id: areaId,
          }
        );

        if (response.data.success) {
          setPackageDetails(response.data.Area_Details[0]);
          const p = response.data.Area_Details[0].pricing;
          setPricing(p);
          setAreaData(true);
        }
      } catch (error) {
        console.log("Error : ", error);
      }
    } else {
      setAreaData(false);
    }
  };
  // const proceedtonext=()=>{
  //   if(selectedValue!="")
  //   setNextpg(true);
  // else
  // alert("Please Select Area first");
  // }
  const proceedtonext = () => {
    if (selectedValue === "") {
      alert("Please select Area first");
      return;
    }
    if (pricselectedMonth === "") {
      alert("Please select Week");
      return;
    }
    setNextpg(true);
  };

  const handleShare = () => {
    // Check if the Web Share API is supported
    if (navigator.share) {
      navigator
        .share({
          title: "Myprega",
          text: "Check out this link!",
          url: window.location.href,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing:", error));
    } else {
      // Fallback if Web Share API is not supported
      alert("Web Share API is not supported in your browser.");
      // You can provide a fallback mechanism here, such as copying the link to the clipboard
    }
  };


  const subbtn = {
    backgroundColor: "#3C4852",
    color: "white",
    width: "200px",
    borderRadius: "12px",
    height: "55px",
    marginRight: "20px",
  }
  const sharebtn = {
    backgroundColor: "white",
    border: "1px solid gray",
    height: "55px",
    borderRadius: "12px",
    width: "60px",
  }
  const yellowclr = {
    height: "20px",
    width: "20px",
    backgroundColor: "yellow",
    borderRadius: "50%",
  }
  const democlass = {
    width: "85%"
  }
  const demoimg = {
    borderRadius: "6px",
  }
  const elemental = {
    border: "1px solid #F5F5F5",
    fontSize: "9px",
    borderRadius: "10px",
  }
  const month = {
    color: "#3C4852",
    fontSize: "12px",
    fontWeight: "600",
  }
  const monthno = {
    color: "#3C4852",
    fontSize: "16px",
    fontWeight: "bolder",
  }
  const monthhead = {
    color: "#3C4852",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "150%",
  }
  return (
    <div className="new-home">
      <div style={{ backgroundColor: nextpg === true ? "#f5f5f5" : "white" }}>
        <Header userid={userid} style={{ zIndex: "1030" }} />

        {nextpg === true ? (
          <Pricingdetails
            selectedValue={selectedValue} // Pass selectedValue
            //  handleChangeGetDetails={handleChangeGetDetails}
            isAtTop={isAtTop}
            imgrad={imgrad}
            pricingparacontent={pricingparacontent}
            pricecherishcare={pricecherishcare}
            headerRef={headerRef}
            packageDetails={packageDetails}
            subbtn={subbtn}
            handlePayment={handlePayment}
            sharebtn={sharebtn}
            handleShare={handleShare}
            democlass={democlass}
            month={month}
            monthno={monthno}
            monthhead={monthhead}
            selectedWeek={selectedWeek}
            pricselectedMonth={pricselectedMonth}
            selectedSonographyOptions={selectedSonographyOptions}
            discountedPrice={discountedPrice}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            couponApplied={couponApplied}
            couponError={couponError}
            finalAmount={finalAmount}
            applyCoupon={applyCoupon}
            setCouponError={setCouponError}
            couponMessage={couponMessage}
            setCouponMessage={setCouponMessage}
          />

        ) : (
          <Pricingmain
            isAtTop={isAtTop}
            imgrad={imgrad}
            selectedValue={selectedValue}
            handleChangeGetDetails={handleChangeGetDetails}
            areas={areas}
            proceedtonext={proceedtonext}
            weekOptions={WEEK_PRICE_OPTIONS}
            selectedWeek={selectedWeek}
            pricselectedMonth={pricselectedMonth}
            handleChangeMonth={handleChangeMonth}
            availableSonographyOptions={availableSonographyOptions}
            selectedSonography={selectedSonography}
            handleSonographyChange={handleSonographyChange}
          />
        )}

        <Footer />
        <InteraktScript />
      </div>
    </div>
  );
}

export default Pricing;
